"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Column = exports.ShopVariantType = exports.LinkedP2PTicketingCategory = exports.TicketingFormCategory = exports.MembershipValidityPeriod = exports.DiscountScope = exports.DiscountType = void 0;
var DiscountType;
(function (DiscountType) {
    DiscountType["Dollars"] = "Dollars";
    DiscountType["Percentage"] = "Percentage";
})(DiscountType || (exports.DiscountType = DiscountType = {}));
var DiscountScope;
(function (DiscountScope) {
    DiscountScope["FullOrder"] = "FullOrder";
    DiscountScope["PerTicketAllRates"] = "PerTicketAllRates";
    DiscountScope["PerTicketSpecificRates"] = "PerTicketSpecificRates";
})(DiscountScope || (exports.DiscountScope = DiscountScope = {}));
var MembershipValidityPeriod;
(function (MembershipValidityPeriod) {
    MembershipValidityPeriod["OneYearAfterPayment"] = "OneYearAfterPayment";
    MembershipValidityPeriod["AtDate"] = "AtDate";
    MembershipValidityPeriod["NoExpiration"] = "NoExpiration";
    MembershipValidityPeriod["OneMonthAfterPayment"] = "OneMonthAfterPayment";
    MembershipValidityPeriod["CustomDuration"] = "CustomDuration";
})(MembershipValidityPeriod || (exports.MembershipValidityPeriod = MembershipValidityPeriod = {}));
var TicketingFormCategory;
(function (TicketingFormCategory) {
    TicketingFormCategory["Event"] = "Event";
    TicketingFormCategory["MembershipV2"] = "MembershipV2";
    TicketingFormCategory["Lottery"] = "Lottery";
    TicketingFormCategory["Sweepstakes"] = "Sweepstakes";
    TicketingFormCategory["Shop"] = "Shop";
    TicketingFormCategory["Auction"] = "Auction";
    TicketingFormCategory["Custom"] = "Custom";
})(TicketingFormCategory || (exports.TicketingFormCategory = TicketingFormCategory = {}));
exports.LinkedP2PTicketingCategory = TicketingFormCategory.Event;
var ShopVariantType;
(function (ShopVariantType) {
    ShopVariantType["Size"] = "Size";
    ShopVariantType["Color"] = "Color";
    ShopVariantType["Custom"] = "Custom";
})(ShopVariantType || (exports.ShopVariantType = ShopVariantType = {}));
var Column;
(function (Column) {
    Column["Fields"] = "fields";
    Column["Translations"] = "translations";
})(Column || (exports.Column = Column = {}));
